<template>
  <el-dialog class="dialog-add-collect" :visible.sync="dialogShow" :show-close="false" width="1200px">
    <!-- <el-alert class="cus-alert mb-20" :closable="false" title="本列表为馆内公开藏品数据，若未找到您要的藏品，请联系馆方进行公开" type="warning" show-icon></el-alert> -->

    <!-- 查询区域 -->
    <!-- <div class="search-wrap">
      <el-form class="form-search" ref="form" :model="form" label-width="85px">
        <el-form-item label="常用条件：">
          <el-input class="item sch-top" placeholder="输入一普编号/藏品名称搜索" v-model="listQuery.key" @keyup.enter.native="getDataList"></el-input>
        </el-form-item>

        <el-form-item label="选择时间：">
          <el-select class="item mr-10" placeholder="常用年代" v-model="listQuery.collectYear" @change="getDataList">
            <el-option v-for="item in form.lastYear" :key="item.dictName" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="产品条件：">
          <el-select class="item mr-10" placeholder="藏品类别" v-model="listQuery.collectType" @change="getDataList">
            <el-option v-for="item in form.type" :key="item.dictName" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>

          <el-select class="item mr-10" placeholder="文物级别" v-model="listQuery.collectLevel" @change="getDataList">
            <el-option v-for="item in form.level" :key="item.dictName" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>

          <el-select class="item mr-10" placeholder="藏品质地" v-model="listQuery.collectTexture" @change="getDataList">
            <el-option v-for="item in form.texture" :key="item.dictName" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>

          <el-select class="item mr-10" placeholder="文物来源" v-model="listQuery.source" @change="getDataList">
            <el-option v-for="item in form.source" :key="item.dictName" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div> -->
    <!-- 表头搜索 -->
    <cmpSearchDict ref="cmpSearchDict" :pageType="`6`" @getParams="getHeadParams"></cmpSearchDict>
    <!-- 已选择 -->
    <p class="m-primary mb-10">已选择：{{multipleSelection.length}}件藏品</p>

    <!-- 表格 -->
    <div class="table">
      <el-table ref="tableRef" stripe @sort-change="sortChange" v-loading="listLoading" :data="tableData" :empty-text="emptyText" @selection-change="handleSelectionChange" element-loading-text="Loading" highlight-current-row :row-key="(row)=>{ return row.collectId}">
      <el-table-column type="selection" width="55"></el-table-column>
       
        <el-table-column :sortable="item.tableName == 'signCode' ||item.tableName ==  'typeCode' || item.tableName == 'collectLevel'" v-for="(item,key) in titleData" :key="key" :prop="item.tableName" :label="item.columnName" show-overflow-tooltip>
          <template slot-scope="scope">
            <viewer :options="{ url: 'data-maxUrl' }" v-if="scope.column.property==='thumbPicture'">
              <img class="g-pointer" :src="(scope.row.collectImages && scope.row.collectImages[0].attPath) || ''" :data-maxUrl="scope.row.collectImages && scope.row.collectImages[0].attPath" alt :onerror="defaultImg" style="width: 36px;height: 36px">
            </viewer>

            <a class="m-btn" type="text" style="margin-left:0" v-else-if="scope.column.property==='collectName'">{{ scope.row.collectName }}</a>

            <span v-else-if="scope.column.property==='attachmentId'">
              <i class='el-icon-check' v-if="scope.row[scope.column.property]"></i>
              <i class='el-icon-minus' v-else></i>
            </span>

            <span v-else-if="scope.column.property==='threeDimensionalInfo'">
              <i class='el-icon-check' v-if="scope.row[scope.column.property]"></i>
              <i class='el-icon-minus' v-else></i>
            </span>
            <span v-else>{{scope.row[scope.column.property]}}</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" :page-sizes="[8, 15, 20, 30]" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />

        <!-- 操作 -->
        <div class="btns">
          <el-button @click="dialogShow=false">取消</el-button>
          <el-button type="primary" @click="add">添加</el-button>
        </div>
      </div>

      <!-- <div class="pagination-container paging">
        <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </div> -->
    </div>

  </el-dialog>
</template>


<script>
import cmpSearchDict from '@cmp/collect/search-dict'

export default {
  data() {
    return {
      dialogShow: false,
      emptyText: '请搜索您要添加的藏品',
      headParams: {
        collectTexture: '', // 质地类别
        collectDisablity: '', // 完残程度
        source: '', // 藏品来源
        qualityRange: '', // 质量范围
        enterCollectRange: '', // enterCollectRange
        collectType: '', // 藏品分类
        collectYear: '', // 藏品年代
        collectLevel: '', // 藏品级别
        isHigh: '', //是否高清图
      },
      order: '1',
      form: {},
      listQuery: {
        currentPage: 1,
        size: 10
      },
      titleData: [{
        columnName: "藏品图片",
        tableName: "thumbPicture"
      }, {
        columnName: "藏品名称",
        tableName: "collectName"
      }, {
        columnName: "总登记号",
        tableName: "signCode"
      }, {
        columnName: "分类号",
        tableName: "typeCode"
      }, {
        columnName: "类别",
        tableName: "collectType"
      }, {
        columnName: "年代",
        tableName: "collectYear"
      }, {
        columnName: "级别",
        tableName: "collectLevel"
      }, {
        columnName: "高清图片",
        tableName: "attachmentId"
      }, {
        columnName: "三维模型",
        tableName: "threeDimensionalInfo"
      }],
      multipleSelection: [], // 已选择
      tableData: [],
      total: 0,
      listLoading: false,
      defaultImg: this.$store.state.app.defaultImg
    }
  },
  components: { cmpSearchDict },
  methods: {
    init() {
      this.dialogShow = true
      this.initList()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    sortChange(column) {
      let order = ""
      if (column.prop == 'signCode') {
        if (column.order == 'ascending') {
          order = '1'
        } else if (column.order == 'descending') {
          order = '2'
        } else {
          order = ""
        }
      } else if (column.prop == 'typeCode') {
        if (column.order == 'ascending') {
          order = '3'
        } else if (column.order == 'descending') {
          order = '4'
        } else {
          order = ""
        }
      } else if (column.prop == 'collectLevel') {
        if (column.order == 'ascending') {
          order = '5'
        } else if (column.order == 'descending') {
          order = '6'
        } else {
          order = ""
        }
      }
      this.order = order
      this.listQuery.currentPage = 1
      this.initList()
    },
    // 初始化表格
    initList() {
      this.listLoading = true
      this.$http
        .get('/collection/list', {
          ...this.listQuery,
          order: this.order,
          ...this.headParams
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 获取头部参数
    getHeadParams(params) {
      let f = 1
      for (let k in params) {
        if (params[k]) {
          f = 0
        }
      }
      // 重置排序
      if (f == 1) {
        this.$refs.tableRef.clearSort()
      }
      this.listQuery.currentPage = 1
      this.headParams = params
      this.order = '1'
      this.initList()
    },


    // 批量添加
    add() {
      if (!this.multipleSelection.length) {
        this.$message({
          message: '请选择藏品',
          type: 'warning'
        })
        return
      }

      let collectIds = []
      this.multipleSelection.forEach(item => {
        collectIds.push(item.collectId)
      })
      this.$http
        .post('/exhibits/batchSaveExhibits', {
          collectIds: collectIds,
          projectId: this.$route.query.projectId
        })
        .then(res => {
          if (res.success) {
            this.$message.success(res.message)
            this.dialogShow = false
            this.$emit('addCall')
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 重置
    // resetForm() {
    //   this.$nextTick(() => {
    //     this.$refs['form'].resetFields()
    //   })
    // },
  }
}
</script>

<style lang="scss" scoped>
.dialog-add-collect {
  .search-wrap {
    .item {
      width: 150px;
    }
    .item.sch-top {
      width: 310px;
    }
  }
  .pagination-container {
    position: relative;
    padding-right: 250px;
    .btns {
      position: absolute;
      right: 0;
      top: -3px;
    }
  }
}
/deep/ .el-dialog__header {
  display: none;
}
</style>

